import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>We have no record of Prior Authorization Number {this.props.data.PANumber} for Client Identification Number {this.props.data.CIN}.</p>
				<p>Please check and confirm the Prior Authorization and member Client Identification Numbers with the prescriber. Both must be correct.</p>
		
			</div>
		);
	}
}